import React, { useEffect, useState } from 'react';
import {
  filterMySupplierPublicInquiriesAction,
  getMySupplierPublicInquiriesAction,
  setSearchValueAction
} from '../../../../../modules/myInquiries/Supplier/Public/Actions';

import { Formik } from 'formik';
import Select from 'react-select';
import {
  supplierPublicInquiriesSelector,
  supplierPublicInquiriesIsLoadingSelector,
  supplierPulbicInquiriesSearchValue,
  pendingSuppliersPublicInquiryCountSelector
} from '../../../../../modules/myInquiries/Supplier/Public/Selectors';

import { getSupplierCategoriesAction } from '../../../../../modules/supplierCategories/Actions';

import { supplierCategoriesAsLabelAndValueSelector } from '../../../../../modules/supplierCategories/Selectors';

import { connect } from 'react-redux';

import List from '../../../../../components/Lists/List';
import ListItem from '../../../../../components/Lists/ListItem';
import InfiniteScroll from 'react-infinite-scroll-component';
import { SearchableSelect, FormGroup } from '../../../../../components/form';
import Search from '../../../../../components/form/Search';
import { supplierDataSelector } from '../../../../../modules/auth/Selectors';
import PublicInquriyComp from '../../../../../components/UI/combine/PublicInquriyComp';
import getLangData from '../../../../../utils/getLangData';

const MySupplierPublicInquiriesList = props => {
  const {
    publicInquiries,
    publicInquiriesIsLoading,
    getPublicInquiries,
    publicInquiriesCount,
    deletePublicSupplierInquiry,
    getSupplierCategories,
    supplierCategories,
    setSearchValue,
    supplierData,
    filterPublicInqiries
  } = props;

  const [size, setSize] = useState(10);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [search, setSearch] = useState('');
  // const supplierId = supplierData._id; // for testing only
  const mappedCID = supplierCategories.map(el => {
    return {
      label: el.name,
      value: el._id
    };
  });
  const supplierCDName = supplierCategories.find(
    el => el._id === supplierData?.supplierCID[0]
  )?.name;
  const handelchange = selectedOption => {
    setSearch(selectedOption.value);
    if (selectedOption.value === 'All') {
      filterPublicInqiries({
        size: 20,
        offset: 0
      });
    } else {
      filterPublicInqiries({
        size: 20,
        offset: 0,
        filterCategory: selectedOption.value
      });
    }
    // console.log(search)
  };
  useEffect(() => {
    filterPublicInqiries({
      size: 20,
      offset: 0
    });
    getSupplierCategories();
  }, []);

  const fetchMore = () => {
    // set hasMore to false if the current items are >= the all items in database !
    if (publicInquiries.length >= publicInquiriesCount) {
      setHasMore(false);
      return false;
    }

    // otherwise get the data from the database
    getPublicInquiries({
      size,
      offset: publicInquiries.length,
      filterCategory: search === 'All' ? '' : search
      // url: `public-supplier-inquiry/search-public-inquiries-for-supplier/`
    });
  };

  const dataLength =
    publicInquiries.length <= publicInquiriesCount
      ? publicInquiries.length
      : publicInquiriesCount;

  console.log(supplierCategories, 'supplierCategories');

  return (
    <>
      <div style={{ width: '70%', margin: '0 auto', marginTop: '40px' }}>
        <p>{getLangData().general_words.filter_category}</p>
        <Select
          options={[
            { value: 'All', label: getLangData().fields.show_all },
            ...mappedCID
          ]}
          onChange={handelchange}
          // formatGroupLabel="Filter"
          placeholder={supplierCDName}
          // defaultValue={supplierCategories.find(
          //   (el) => el.value === supplierData.supplierCID[0]
          // )}
        />
      </div>
      <InfiniteScroll
        dataLength={dataLength}
        hasMore={hasMore}
        next={fetchMore}
        style={{ overflow: 'hidden' }}
      >
        <div className='mt-5'>
          <PublicInquriyComp
            cardTitle={getLangData().components.public_inquiry.public_inquiry}
            isLoading={publicInquiriesIsLoading}
            items={publicInquiries}
            edit='/my-public-inquiries-supplier'
          >
            {/* <Link to='/my-supplier-products/create' className='btn btn-primary'>
            {getLangData().buttons.add_new}
          </Link> */}
          </PublicInquriyComp>
        </div>
        {/* <div className='table row block--container my-5'>
          <List
            isLoading={publicInquiriesIsLoading}
            header={{ items: ['Inquiries'], actions: ['View'] }}
            items={publicInquiries}
          >
            <table className='table'>
              <tbody>
                {publicInquiries.map(
                  ({ businessName, message, _id, title }) => {
                    return (
                      <ListItem
                        //  type='multi'
                        name={title}
                        // data={[message]}
                        key={_id}
                        viewLink={`/my-public-inquiries-supplier/${_id}`}
                        // onDelete={() => deletePublicSupplierInquiry(_id) }
                      >
                        {console.log(supplierCDName)}
                      </ListItem>
                    );
                  }
                )}
              </tbody>
            </table>
          </List>
        </div> */}
      </InfiniteScroll>
    </>
  );
};

const mapStateToProps = state => ({
  publicInquiries: supplierPublicInquiriesSelector(state),

  publicInquiriesIsLoading: supplierPublicInquiriesIsLoadingSelector(state),
  supplierCategories: supplierCategoriesAsLabelAndValueSelector(state),
  searchValue: supplierPulbicInquiriesSearchValue(state),
  publicInquiriesCount: pendingSuppliersPublicInquiryCountSelector(state),
  supplierData: supplierDataSelector(state)
});

export default connect(mapStateToProps, {
  getPublicInquiries: getMySupplierPublicInquiriesAction,
  filterPublicInqiries: filterMySupplierPublicInquiriesAction,
  getSupplierCategories: getSupplierCategoriesAction,
  setSearchValue: setSearchValueAction
  // deletePublicSupplierInquiry: deleteSupplierPublicInquiryAction,
})(MySupplierPublicInquiriesList);
